import { render, staticRenderFns } from "./consumption.vue?vue&type=template&id=48469d6e&scoped=true&"
import script from "./consumption.vue?vue&type=script&lang=js&"
export * from "./consumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48469d6e",
  null
  
)

export default component.exports